import React, {
  useEffect,
  ReactElement,
  useState,
  useCallback,
  useRef,
} from 'react';
import * as S from './style';
import { Label } from 'components';
import { ReactComponent as UploadIcon } from 'assets/img/common/ic_object_camera_fill.svg';
import {
  LABEL_IMG_UPLOAD,
  LABEL_LOGO_UPLOAD,
  BUTTON_DELETE_IMAGE,
  CAPTION_IMAGE_UPLOAD,
} from 'commons/ZimssaString';
import { imageUpload, deleteFile } from 'commons/ZimssaHelper';

export interface Props {
  inputName: string;
  imgDir: string;
  value?: string;
  isDeleteBtn?: boolean;
  isServiceLogo?: boolean;
  guideMessageList?: string[];
  onChangeHandler?: (type: any, value: string) => void;
}

function FileImg({
  inputName,
  imgDir,
  value,
  isDeleteBtn,
  isServiceLogo,
  guideMessageList,
  onChangeHandler,
}: Props): ReactElement {
  const inputRef = useRef<HTMLInputElement>(null);
  const [background, setBackground] = useState<string>();
  const [imgName, setImgName] = useState<string>();

  const onChangeFile = useCallback(async () => {
    try {
      const { data, file } = await imageUpload(
        inputRef,
        imgDir,
        1024 * 1024 * 10
      );

      setBackground(data);
      setImgName(file.name);

      onChangeHandler && onChangeHandler(inputName, data);
    } catch (error) {
      let message = 'Unknown Error';

      if (error instanceof Error) {
        if (error.message === 'NO FILE SELECTED') return;
        message = error.message;
      }

      alert(message);
    }
  }, [imgDir, inputName, onChangeHandler]);

  const onClickImageDelete = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      deleteFile(inputRef);
      setBackground('');
      setImgName('');

      onChangeHandler && onChangeHandler(inputName, '');
    },
    [inputName, onChangeHandler]
  );

  useEffect(() => {
    setBackground(value ?? '');
  }, [value]);

  return (
    <>
      <S.FileImgContainer background={background}>
        {background ? (
          <S.ImageCover>
            <S.InfoWrapper>
              <S.LabelFileName>{imgName}</S.LabelFileName>
              {isDeleteBtn ? (
                <S.BtnDelete
                  fontStyle={'body2'}
                  color={'gray_opacity_50'}
                  backGroundColor={'gray_opacity_400'}
                  onClick={onClickImageDelete}
                >
                  {BUTTON_DELETE_IMAGE}
                </S.BtnDelete>
              ) : null}
            </S.InfoWrapper>
            <Label
              contents={CAPTION_IMAGE_UPLOAD}
              fontStyle={'caption'}
              color={'gray_opacity_50'}
            />
          </S.ImageCover>
        ) : (
          <S.InputFileWrapper>
            <S.InputFile
              type={'file'}
              accept={'image/*'}
              ref={inputRef}
              onChange={onChangeFile}
            />
            <S.LabelWrapper>
              <UploadIcon />
              <Label
                fontStyle={'body2'}
                color={'gray_opacity_800'}
                contents={isServiceLogo ? LABEL_LOGO_UPLOAD : LABEL_IMG_UPLOAD}
              />
            </S.LabelWrapper>
          </S.InputFileWrapper>
        )}
      </S.FileImgContainer>
      <S.GuideTextContainer>
        {guideMessageList?.map((message, index) => (
          <S.GuideText key={index}>{message}</S.GuideText>
        ))}
      </S.GuideTextContainer>
    </>
  );
}

export default FileImg;
